<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace'],
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
    }),
    items() {
      return this.cannedMessages.map(cannedMessage => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: cannedMessage.content,
        fileUrls: cannedMessage.file_urls || [],
      }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    fetchCannedResponses() {
      this.$store.dispatch('getCannedResponse', { searchKey: this.searchKey });
    },
    async handleMentionClick(item = {}) {
      this.$emit('replace', item.description);
      // Anexar files da canned response automaticamente
      if (item.fileUrls && item.fileUrls.length > 0) {
        for (const fileInfo of item.fileUrls) {
          try {
            const response = await fetch(fileInfo.url);
            const blob = await response.blob();
            const file = new File([blob], fileInfo.filename, { type: fileInfo.content_type });
            // Disparar evento global para o ReplyBox capturar
            window.dispatchEvent(new CustomEvent('centertel:attach-file', { detail: { file } }));
          } catch (e) {
            console.error('[CannedResponse] attach file error:', e);
          }
        }
      }
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  />
</template>
